module.exports = __webpack_public_path__ + "img/tv.4758de0b.png";